module.exports = __webpack_public_path__ + "static/Image15@2x-47476e7baf72f21a103df37e56dc8496.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image15@2x.jpg
// module id = 908
// module chunks = 227233210825294 244429959259914